import React, {Fragment} from "react";
import StepButton from "components/Step/StepButton";
import {Input} from "reactstrap";
import UtilityCountryService from "services/Util/UtilityCountryService";
import StepOptionSelection from "components/Step/StepOptionSelection";
import StepQuestion from "components/Step/StepQuestion";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import IdTypeEnum from "domain/Customer/IdTypeEnum";
import StepLoadingComponent from "components/Step/StepLoadingComponent";


const SOUTH_AFRICA_ALPHA3 = "ZAF";

export default class NationalityCaptureStep extends React.Component {

    static COUNTRY_LIST = null;

    static loadCountryList(callback) {
        UtilityCountryService.retrieveCountryList().then(response => {
            if (Array.isArray(response)) {
                NationalityCaptureStep.COUNTRY_LIST = response;
            } else {
                NationalityCaptureStep.COUNTRY_LIST = [];
            }
            if (callback) callback();
        });
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: true,
            inputText: "",
            visibleIndexes: [], // countries that are valid for the selected Id Type
            renderIndexes: [], // countries to actually render
            selectedIndex: -1
        };

        this.filterCountries = this.filterCountries.bind(this);
    }

    componentDidMount() {
        if (NationalityCaptureStep.COUNTRY_LIST === null || NationalityCaptureStep.COUNTRY_LIST.length === 0) {
            NationalityCaptureStep.loadCountryList(this.onCountriesLoaded.bind(this));
        } else {
            this.onCountriesLoaded();
        }
    }

    onCountriesLoaded() {
        let selectedIndex = this.getNationalityIndex(this.props[RegistrationElements.NATIONALITY]);
        let southAfricaIndex = this.getNationalityIndex(SOUTH_AFRICA_ALPHA3);

        let visibleIndexes = [];
        for (let index = 0; index < NationalityCaptureStep.COUNTRY_LIST.length; index++) {
            if (index === selectedIndex || index === southAfricaIndex) continue;
            visibleIndexes.push(index);
        }

        if (this.props[RegistrationElements.ID_TYPE] === IdTypeEnum.SA_ID) {
            visibleIndexes.splice(0, 0, southAfricaIndex);
        } else if (selectedIndex === southAfricaIndex) {
            selectedIndex = -1;
        }

        if (selectedIndex >= 0 && selectedIndex !== southAfricaIndex) {
            visibleIndexes.splice(0, 0, selectedIndex);
        }

        this.setState({
            loading: false,
            selectedIndex: selectedIndex,
            visibleIndexes: visibleIndexes,
            renderIndexes: this.getRenderIndexList(visibleIndexes, "")
        });
    }

    getNationalityIndex(value) {
        for (let i = 0; i < NationalityCaptureStep.COUNTRY_LIST.length; i++) {
            if (NationalityCaptureStep.COUNTRY_LIST[i].alpha3 === value) {
                return i;
            }
        }
        return -1;
    }

    setSelectedIndex(index) {
        this.setState({
            selectedIndex: index
        });
    }

    filterCountries() {
        let searchText = this.state.inputText.toLowerCase();
        this.setState({
            renderIndexes: this.getRenderIndexList(this.state.visibleIndexes, searchText)
        });
    }

    getRenderIndexList(indexList, searchText) {
        let filteredIndexes = [];
        indexList.forEach((singleIndex) => {
            if (NationalityCaptureStep.COUNTRY_LIST[singleIndex].name.toLowerCase().startsWith(searchText)) {
                filteredIndexes.push(singleIndex);
            }
        });

        if (this.state.selectedIndex >= 0 && filteredIndexes.indexOf(this.state.selectedIndex) < 0) {
            filteredIndexes.splice(0, 0, this.state.selectedIndex);
        }

        return filteredIndexes;
    }

    scheduleFilter() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.filterCountries, 150);
    }

    onInputChanged(e) {
        this.setState({
                inputText: e.target.value
            }, this.scheduleFilter
        );
    }

    onNextClick() {
        if (this.props.onNextClick) {
            let selectedItem = NationalityCaptureStep.COUNTRY_LIST[this.state.selectedIndex];
            this.props.onNextClick(selectedItem.alpha3);
        }
    }

    render() {
        if (this.state.loading)
            return <StepLoadingComponent
                style={{position: "inherit", margin: "auto", marginTop: "25%"}}
            />
        return <div className={"step_card_no_scroll"}>
            <StepQuestion>
                Please confirm your nationality:
            </StepQuestion>
            <Input
                className={"step_selection_search"}
                type={"text"}
                value={this.state.inputText}
                placeholder={"Search"}
                onChange={this.onInputChanged.bind(this)}
            />
            <br/>
            <div className={"step_selection_list"} style={{
                maxHeight: "calc(100% - 215px)"
            }}>
                {this.renderIndexes()}
            </div>
            <StepButton
                onClick={this.onNextClick.bind(this)}
                disabled={this.state.selectedIndex === -1}
            >
                {this.props.nextText || "Next"}
            </StepButton>

            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {this.props.backText || "Back"}
            </StepButton>
        </div>
    }

    renderIndexes() {
        return <Fragment>
            {
                this.state.renderIndexes.length === 0 && <div className={"no_results"}>
                    No countries like "{this.state.inputText}."
                </div>
            }
            {
                this.state.renderIndexes.map(singleIndex => {
                    return this.renderSingleCountry(NationalityCaptureStep.COUNTRY_LIST[singleIndex], singleIndex);
                })
            }
        </Fragment>
    }

    renderSingleCountry(singleCountry, index, extraClass = "") {
        let isCurrentlySelected = this.state.selectedIndex === index;
        return <Fragment key={index}>
            <StepOptionSelection
                key={index}
                className={(isCurrentlySelected ? "active" : "") + " " + extraClass}
                onClick={() => {
                    this.setSelectedIndex(index);
                }}
            >
                <div className="step_selection_item">
                    <div className="step_selection_item_icon">
                        <span className={"flag flag-icon flag-icon-" + singleCountry.iconClass}/>
                    </div>
                    <div className="step_selection_item_text">
                        <span>{singleCountry.nameOriginal}</span>
                    </div>
                    <div className="step_selection_item_check">
                        {isCurrentlySelected && <i className={"fa fa-check"}/>}
                    </div>
                </div>

            </StepOptionSelection>
        </Fragment>
    }
}
